import Modal from './code/Scripts/components/modal.vue';

export default {
  components: {
    Modal,
  },
};
